import React, {Component} from 'react';
import PropTypes from 'prop-types';
import {Row, Col} from 'react-bootstrap';
import './NormalizationContainer.scss';

class NormalizationViewDataResume extends Component {
  shouldComponentUpdate(nextProps) {
    const {normalizationState: oldNormalizationState} = this.props;
    const {
      reagentName: oldReagentName,
      diluentName: oldDiluentName,
      targetConcentration: oldTargetConcentration,
      previewData: oldPreviewData,
    } = oldNormalizationState;

    const {normalizationState} = nextProps;
    const {reagentName, diluentName, targetConcentration, previewData} = normalizationState;

    if (oldReagentName !== reagentName) {
      return true;
    }

    if (oldDiluentName !== diluentName) {
      return true;
    }

    if (oldTargetConcentration !== targetConcentration) {
      return true;
    }

    if (oldPreviewData !== previewData) {
      return true;
    }

    return false;
  }

  render() {
    const {normalizationState} = this.props;
    const {reagentName, diluentName, targetConcentration, previewData} = normalizationState;

    let totalDiluent = 0;

    for (let index = 0; index < previewData.length; index += 1) {
      totalDiluent += previewData[index].diluentVol * 10;
    }

    return (
      <div className="setting-container">
        <div className="block-section">
          <div className="sub-section-title">Data Resume</div>
          <Row>
            <Col xs={6} sm={6} md={6}>
              Reagent Name
            </Col>
            <Col xs={6} sm={6} md={6} className="break-word">
              {`: ${reagentName}`}
            </Col>
          </Row>
          <Row>
            <Col xs={6} sm={6} md={6}>
              Diluent Name
            </Col>
            <Col xs={6} sm={6} md={6} className="break-word">
              {`: ${diluentName}`}
            </Col>
          </Row>
          <Row>
            <Col xs={6} sm={6} md={6}>
              Total Diluent
            </Col>
            <Col xs={6} sm={6} md={6}>
              {`: ${totalDiluent / 10}`}
            </Col>
          </Row>
          <Row>
            <Col xs={6} sm={6} md={6}>
              Target Concentration
            </Col>
            <Col xs={6} sm={6} md={6}>
              {`: ${targetConcentration}`}
            </Col>
          </Row>
        </div>
      </div>
    );
  }
}

export default NormalizationViewDataResume;

NormalizationViewDataResume.propTypes = {
  normalizationState: PropTypes.any.isRequired,
};
